/**
 * Convert a value to a label. If the value is null or undefined, return "No Value".
 * @param value - The value to convert
 * @returns The label
 */
export const toLabel = <T>(value: T) => {
  return value ?? "No Value";
};
